exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ItemCard{width:calc(100% - 68px);background:#fff;border:1px solid #d1d1d1;margin-top:20px;border-radius:5px;position:relative}.ItemCard img{max-width:100%}.ItemCard .actions{position:absolute;right:-49px;top:3px}.ItemCard .actions .block-icon{width:48px;height:48px;background:#fff;align-items:center;justify-content:center;display:flex;border:1px solid #ddd}.ItemCard .actions .icon{cursor:pointer}.ItemCard hr{margin:0!important}.ItemCard dl,.ItemCard ol,.ItemCard ul{margin-left:30px}.ItemCard .answer,.ItemCard .question{padding:10px;height:360px}.ItemCard .question{display:flex}.ItemCard .question .image{cursor:pointer;width:33%;display:flex;align-items:center;justify-content:center;flex-direction:column}.ItemCard .question .image img{max-width:100%}.ItemCard .question .text{display:flex;flex:auto;align-items:center;width:67%}.image-preview-container{z-index:9999!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Card/components/Cards/components/Item/style.scss
// module id = 5132
// module chunks = 0